import { render } from "./EditorToolbar.vue?vue&type=template&id=a7c4dc12"
import script from "./EditorToolbar.vue?vue&type=script&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__